import type { Clock, IdGenerator } from "../ports/clock";
import type { DiaryRepository, FoodRepository, WeekPlanRepository } from "../ports/repositories";
import type { CalendarDate } from "../../domain/shared/calendar-date";
import type { FoodPortion } from "../../domain/foods/food";
import type { LoggingIntent } from "../../domain/check-in/state-machine";
import { assertLoggingAllowed } from "../../domain/check-in/state-machine";
import { createDiaryEntry, type DiaryEntry } from "../../domain/diary/diary-entry";

export async function logFood(
  dependencies: {
    readonly foods: FoodRepository;
    readonly diary: DiaryRepository;
    readonly weekPlans: WeekPlanRepository;
    readonly clock: Clock;
    readonly ids: IdGenerator;
  },
  input: {
    readonly foodId: string;
    readonly portion: FoodPortion;
    readonly date: CalendarDate;
    readonly meal?: string;
    readonly intent?: LoggingIntent;
  },
): Promise<DiaryEntry> {
  const [food, plan] = await Promise.all([dependencies.foods.getById(input.foodId), dependencies.weekPlans.getOpen()]);
  if (!food) throw new Error("Food not found");
  if (!plan) throw new Error("No active week plan");
  assertLoggingAllowed(plan, dependencies.clock.today(), input.date, input.intent);
  const entry = createDiaryEntry({
    id: dependencies.ids.next(),
    date: input.date,
    meal: input.meal,
    food,
    portion: input.portion,
    now: dependencies.clock.now(),
  });
  await dependencies.diary.save(entry);
  return entry;
}
